// @flow
import React from 'react';
import { connect } from 'react-redux';
import Modal from './Modal';
import {
  selectBookletUrl,
  selectBookletInitialPage,
  selectOpenModalTypeIs,
} from '../../selectors/modals';
import * as uiActions from '../../actions/ui';
import styles from './BookletModal.css';
import BookletViewer from '../common/BookletViewer';

type OwnProps = {};

type MapStateToProps = {
  isOpen: boolean,
  bookletUrl: string,
  initialPage?: number,
};

type DispatchProps = {
  hideModal: Function,
};

type Props = OwnProps & MapStateToProps & DispatchProps;

const BookletModal = ({ isOpen, hideModal, bookletUrl, initialPage }: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={hideModal}
      onRequestClose={hideModal}
      contentLabel="booklet-modal"
    >
      <div className={styles.modal}>
        <BookletViewer bookletUrl={bookletUrl} initialPage={initialPage} />
      </div>
    </Modal>
  );
};

function mapStateToProps(state: Object): MapStateToProps {
  return {
    isOpen: selectOpenModalTypeIs(state, 'BOOKLET_MODAL'),
    bookletUrl: selectBookletUrl(state),
    initialPage: selectBookletInitialPage(state),
  };
}

const dispatchProps: DispatchProps = {
  hideModal: uiActions.hideModal,
};

export default connect(mapStateToProps, dispatchProps)(BookletModal);
